export class CheckWithdrawalDeadLineHour {
  static checkDeadline(last_updated_hour?: number): boolean {
    const current_time = new Date();
    const current_hour = current_time.getHours();
    const current_day = current_time.getDay();
    return !last_updated_hour
      || (current_hour >= 13 && current_day === 4 && last_updated_hour <= 13);
  }
}
